import { Buffer } from "buffer";

export const cloneSearchParams = (searchParams: URLSearchParams) => {
  const cloned = new URLSearchParams();
  for (const [key, value] of searchParams.entries()) {
    cloned.append(key, value);
  }
  return cloned;
}

export const isEmailFormat = (email: string) => {
  const emailRegex = /^[a-zA-Z0-9._%+'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
}

export const capitalize = (str: string, onlyFirstLetter = false) => {
  if (onlyFirstLetter) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export const emailRegex = /\S+@\S+\.\S+/;

export const containsEmailDomain = (email: string, domains?: string[]): boolean => {
  if (domains === undefined) {
    return false 
  }

  for(const domain of domains) {
    if (email.endsWith(domain)) {
      return true;
    }
  }

  return false;
}

export const encodeBase64 = (data: unknown) => {
  return Buffer.from(JSON.stringify(data)).toString('base64');
}

export const decodeBase64 = (data: string) => {
  return Buffer.from(data, 'base64').toString('utf-8');
}